module.exports = __webpack_public_path__ + "static/media/icomoon.126e4331.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.woff
// module id = 1051
// module chunks = 114